import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Thankyou.css";
import StaticPageHeaders from "../../../Components/StaticPageHeaders";
import NavbarCustom from "../../../Components/NavbarCustom";
import SEO from "../../../Components/SEO";
import { CheckCircle } from "lucide-react";
import { useSummerCamp } from "../../../APIContext/summerCampContext";
import { useNewUser } from "../../../APIContext/NewUserContext";
import { useLogin } from "../../../APIContext/LoginContext";

const Thankyou = () => {
  const { dataVpayment } = useSummerCamp();
  const { dataVpaymentGuest } = useNewUser();
  const { setUser } = useLogin();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  // let userlg = JSON.parse(localStorage.getItem("user"));
  // console.log("User from localStorage:", userlg);

  const getLocalUser = () => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  };

  let userlg = getLocalUser();

  useEffect(() => {
    try {
      if (dataVpayment && userlg) {
        setData(dataVpayment);
      } else if (dataVpaymentGuest && !userlg) {
        setData(dataVpaymentGuest);

        if (dataVpaymentGuest?.payload?.user) {
          try {
            localStorage.setItem(
              "user",
              JSON.stringify(dataVpaymentGuest.payload.user),
            );
            localStorage.setItem(
              "accessToken",
              dataVpaymentGuest.payload?.access,
            );
            localStorage.setItem(
              "refreshToken",
              dataVpaymentGuest.payload?.refresh,
            );
          } catch (storageError) {
            console.warn("Safari blocked localStorage:", storageError);
          }

          setUser(dataVpaymentGuest.payload.user);
        }
      } else {
        navigate("/", { replace: true });
      }
    } catch (err) {
      console.error("Thank You page error:", err);
      navigate("/", { replace: true });
    }
  }, [dataVpayment, dataVpaymentGuest, navigate, setUser]);

  if (!data) {
    return null; // or loader component
  }

  const user = data?.payload?.user;
  const registration = data?.registration;

  return (
    <>
      <SEO
        title="Thank You - Shootin School Inc"
        description="Thank you for your payment and registration with Shootin School"
        url="https://shootinschool.com/thank-you"
      />

      <NavbarCustom />
      <StaticPageHeaders title="Thank You" />

      <div className="thank-you-container brightness">
        <div className="thank-you-card brightness">
          <CheckCircle className="success-icon" />

          <h2>
            <span className="text-clip">
              Summer Camp Registration Successful
            </span>{" "}
            🎉
          </h2>

          <p className="subtitle text-clip">
            Thank you{" "}
            <strong>
              {user?.first_name || userlg?.first_name}{" "}
              {user?.last_name || userlg?.last_name}
            </strong>{" "}
            for completing your registration.
          </p>

          <div className="info-grid">
            <div>
              <span className="text-clip">Email</span>
              <p className="text-clip">{user?.email || userlg?.email}</p>
            </div>

            <div>
              <span className="text-clip">Program</span>
              <p className="text-clip">{registration?.offering?.name}</p>
            </div>

            <div>
              <span className="text-clip">Year</span>
              <p className="text-clip">{registration?.offering?.year}</p>
            </div>

            <div>
              <span className="text-clip">Total Paid</span>
              <p className="text-clip">${registration?.total_price}</p>
            </div>

            <div>
              <span className="text-clip">Payment Status</span>
              <p className="paid-status">
                {registration?.paid ? "Paid ✅" : "Pending ❌"}
              </p>
            </div>

            {/* <div>
              <span>Players</span>
              <p>{registration?.players.map((player) => player.name).join(", ")}</p>
            </div>

            <div>
              <span>Weeks</span>
              <p>{registration?.total_weeks}</p>
            </div> */}

            <div className="players-section">
              <span className="text-clip">Players & Weeks</span>

              {registration?.players?.map((player) => (
                <div key={player.id} className="player-block">
                  <p className="player-name text-clip">
                    Player Name: {player.name}
                  </p>
                  <p className="player-name text-clip">Weeks: </p>

                  <ul className="week-list">
                    {player.weeks.map((week) => (
                      <li key={week.id}>
                        <strong className="text-clip">
                          Week {week.week_number}
                        </strong>{" "}
                        {/* <span className="week-dates">
              ({week.start_date} – {week.end_date})
            </span> */}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="thank-you-actions">
            <Link to="/" className="btn-primary">
              Go to Home
            </Link>
            <Link to="/profile/my-summer-camp" className="btn-secondary">
              <span className="text-clip">View Dashboard</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Thankyou;
